/** Selected synthetic services used in the local CLI output. */
export const exampleServices = [
  {
    service_id: "example-web-01",
    name: "web-01",
    type: "vm",
    live_state: "running",
  },
  {
    service_id: "example-api-worker",
    name: "api-worker",
    type: "container",
    live_state: "running",
  },
];

/** Commands and envelope match web/cli/ecocloudctl.mts; no commands execute. */
export const exampleCommands = [
  {
    label: "Command help",
    command: "ecocloud help services list",
    output:
      "Usage: ecocloud services list\nSummary: List the account's services (VMs, containers, functions).\nCapability: services.list (v1)\nRisk Class: read",
  },
  {
    label: "List services",
    command: "ecocloud services list --output json",
    output: JSON.stringify(
      {
        apiVersion: "ecocloudctl/v1",
        kind: "serviceList",
        request_id: null,
        items: exampleServices,
        next_cursor: null,
      },
      null,
      2,
    ),
  },
];
